import { Box, Button } from '@amzn/awsui-components-console';
import React from 'react';

export interface EmptyStateProps {
	title: string;
	description?: string;
	testId?: string;
	action?: {
		text: string;
		onClick: () => void;
		variant?: 'primary' | 'normal';
	};
}

export default function EmptyState({
	title,
	description,
	testId = 'empty-state-message',
	action,
}: EmptyStateProps) {
	return (
		<Box
			textAlign="center"
			color="inherit"
			data-testid={testId}
			padding={{ vertical: 'l', horizontal: 'm' }}
		>
			<Box variant="h3" color="text-status-inactive" margin={{ bottom: 's' }}>
				{title}
			</Box>
			{description && (
				<Box variant="p" color="text-body-secondary">
					{description}
				</Box>
			)}
			{action && (
				<Button
					variant={action.variant || 'primary'}
					onClick={action.onClick}
				>
					{action.text}
				</Button>
			)}
		</Box>
	);
}